import { SortOption } from '.';

export const sortOptions: SortOption[] = [
  { label: 'Ny enhet', icon: 'plus', color: 'primary', value: 'newEnhet', active: false },
  {
    label: 'Enhet funnet',
    icon: 'edit',
    color: 'success',
    value: 'relatedToLopenr',
    active: false,
  },
  {
    label: 'Innmelding',
    icon: 'alert',
    color: 'success',
    value: 'hasInnmeldtDato',
    active: false,
  },
  {
    label: 'Utmelding',
    icon: 'alert',
    color: 'warning',
    value: 'hasUtmeldtDato',
    active: false,
  },
  {
    label: 'Nedleggelse',
    icon: 'alert',
    color: 'warning',
    value: 'hasNedlagtDato',
    active: false,
  },
];
